import React, { StrictMode } from "react";
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DialogProvider } from "./DialogProvider";
// import { registerLocale } from "react-datepicker";
// import th from "date-fns/locale/th";

import './assets/scss/main.css?v=278';
// import './assets/scss/main2.scss??v=278';
import './assets/scss/custom-select.scss?v=278';

// console.log('NODE_ENV = ' + process.env.NODE_ENV);



// registerLocale("th", th); 


if (Capacitor.isNativePlatform()) {
  // PWAs get status bar icon contrast for free from manifest.json's theme_color
  // ("#000000") — Chrome computes it automatically for installed/standalone PWAs.
  // Capacitor's native WebView has no equivalent, so without this the status bar
  // icons default to a color that blends into the background. Keep in sync with
  // manifest.json's theme_color if that's ever changed.
  // 20261022: setBackgroundColor removed - deprecated Window.setStatusBarColor (Play Console warning) and a no-op
  // on edge-to-edge Android; the black area behind the bars now comes from MainActivity (EdgeToEdge + decor
  // background) and styles.xml windowBackground. iOS never used it.
  // StatusBar.setBackgroundColor({ color: '#000000' }).catch(() => {});
  StatusBar.setStyle({ style: Style.Dark }).catch(() => {}); // Dark = light icons, for a dark background
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Create a QueryClient instance
const queryClient = new QueryClient();

const onHello = () => {
  // window.location.href = 'https://chat9.2smetal.com/_uploadwp/2025/07/29/ca04ac20-2826-4798-9dca-06bc722ecde2/77/EmployeeLastDateConnectChat.xlsx';
  // window.location.href = "https://chat9_files.2smetal.com/file/_uploadwp/2025/07/29/ca04ac20-2826-4798-9dca-06bc722ecde2/77/EmployeeLastDateConnectChat.xlsx";
  // window.open("https://chat9_files.2smetal.com/file/_uploadwp/2025/07/29/ca04ac20-2826-4798-9dca-06bc722ecde2/77/EmployeeLastDateConnectChat.xlsx");
}

root.render(
  // <StrictMode>
    <Provider store={configureStore({})}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <DialogProvider>
            <App />
          </DialogProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  // </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
